import { toState } from '../base/redux/functions';
/**
 * Tells whether or not the notifications should be displayed within
 * the conference feature based on the current Redux state.
 *
 * @param {Object|Function} stateful - The redux store state.
 * @returns {boolean}
 */
export function shouldDisplayNotifications(stateful) {
    const state = toState(stateful);
    const { calleeInfoVisible } = state['features/invite'];
    return !calleeInfoVisible;
}
/**
 *
 * Returns true if polls feature is disabled.
 *
 * @param {(Function|Object)} stateful - The (whole) redux state, or redux's
 * {@code getState} function to be used to retrieve the state
 * features/base/config.
 * @returns {boolean}
 */
export function arePollsDisabled(stateful) {
    const state = toState(stateful);
    const { conference } = state['features/base/conference'];
    if (!conference || typeof conference.getPolls !== 'function') {
        return true;
    }
    const polls = conference.getPolls();
    if (!polls || typeof polls.isSupported !== 'function' || !polls.isSupported()) {
        return true;
    }
    return state['features/base/config']?.disablePolls;
}
